var elms = document.getElementsByClassName('splide__default')

var elmsOptions = {
  type: 'slide',
  width: '1000px',
  speed: 650,
  perPage: 4,
  perMove: 4,
  pagination: false,
  drag: true,
  snap: true,
  flickPower: 200,
  easing: 'ease',
  breakpoints: {
    1140: {
      perPage: 3,
      perMove: 3,
    },
    770: {
      perPage: 2,
      perMove: 2,
    },
    500: {
      perPage: 1,
      perMove: 1,
    },
  },
}

let splideInstances = {}
for (var i = 0; i < elms.length; i++) {
  var spliders = new Splide(elms[i], elmsOptions)
  spliders.mount()
  splideInstances[elms[i].id] = spliders
}


// featured product splide
featuredProductDefaults = {
  type: 'slide',
  rewind: true,
  pagination: false,
  arrows: false,
  gap: 10,
  perPage: 1,
  breakpoints: {
    920: {
      padding: {left: 0, right: '40%'},
      gap: 30,
    },
  },
}

featuredProductThumbsDefaults = {
    type: 'slide',
  gap: 10,
  rewind: true,
  pagination: false,
  isNavigation: true,
  perPage: 3,
  drag: false,
  padding: {left: 5, right: 5},
}



/*  Splide Object */ 
let sliderArray = []
const AKSliderObj = {
    slideshow: (slider_id, section_data) => { 
        // console.log(`slideshow READY: ${slider_id} | ${section_data}`);
        // let slideshow = slideshowInstance[slider_id];
        slideshow = new Splide( '#'+section_data+' .splide');

        const overlayAnimation  = document.querySelector('#'+section_data+' .splide_slideshow').getAttribute('data-animation')
        const sliderVideos = document.querySelectorAll('#'+section_data+' .splide__list video');
        const videoStatus = () => {
            let active_slider = document.querySelector('#'+section_data+' .splide__list .is-active');
            let active_video = active_slider.querySelector('video');

            sliderVideos.forEach(element => {
                element.pause()
            });

            if(active_slider.children[0].tagName == 'VIDEO') {
            active_video.play();
            }
        }

        slideshow.on('visible', function(e) {
            let active_li = e.slide

            if(overlayAnimation == 'overlay_slide_in') {
                let content = active_li.querySelector('.Slideshow__overlay-content')
                content.classList.add('slide_up')
            }


            let animationMedia = active_li.querySelector('.slideshow-media')
            if(animationMedia.tagName === 'IMG') {
                animationMedia.classList.add('scale')
            }
        })
        slideshow.on('hidden', function(e) {
            let hidden_li = e.slide
            let content = hidden_li.querySelector('.Slideshow__overlay-content')
            content.classList.remove('slide_up')

            let animationMedia = hidden_li.querySelector('.slideshow-media')
            if(animationMedia.tagName === 'IMG') {
                animationMedia.classList.remove('scale')
            }
        })
        slideshow.on('active', function(e) {
            videoStatus();
        })

        slideshow.mount();            
    },
    featured_product: (slider_id, section_data) => { 
        let product_slider = document.querySelectorAll('#'+section_data+' .ak-splide-product')
        let thumb_slider = document.querySelectorAll('#'+section_data+' .ak-splide-thumbs')

        for (var i = 0; i < product_slider.length; i++) {
            let product_splide =  new Splide( product_slider[i], featuredProductDefaults);
            let product_thumbs_splide =  new Splide( thumb_slider[i], featuredProductThumbsDefaults);

            sliderArray.push(product_thumbs_splide)

            product_splide.sync(product_thumbs_splide)
            product_splide.mount()
            product_thumbs_splide.mount()
        }
    }
    

    /*
    featured_product: {
        // myNestedMethod: function myNestedMethod(params) {console.log(`${slider_id} | ${params}`)}
        
        console.log('############')
        console.log(section_data)
         myNestedMethod: (params) => {
             // console.log(`${slider_id} | ${params}`)
             alert('TEST');
         }
    }
    */
}

document.addEventListener( 'DOMContentLoaded', function () {
    /* get all data-section-class elements */
    const getSectionData = document.querySelectorAll('[data-section-class]');

    for (let i in getSectionData) if (getSectionData.hasOwnProperty(i)) {        
        let item = getSectionData[i].getAttribute('data-section-class')
        // initialise splide object variation
        if(item) {
            let item_data = getSectionData[i].getAttribute('id')
            AKSliderObj[item](i, item_data);
        }
    }



    /* sopify design mode */
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (e) {        
            if (elms.length > 0) {
                for (var i = 0; i < elms.length; i++) {
                    var spliders = new Splide(elms[i], elmsOptions)
                    spliders.mount()
                }
            }            
            
            const getSectionDataTemp = document.querySelectorAll('[data-section-class]');

            for (let i in getSectionDataTemp) if (getSectionDataTemp.hasOwnProperty(i)) {        
                let item = getSectionDataTemp[i].getAttribute('data-section-class')

                // initialise splide object variation
                if(item) {
                    let item_data = getSectionDataTemp[i].getAttribute('id')
                    AKSliderObj[item](i, item_data);
                }
            }
        })

        let selectedSectionID;
      
        document.addEventListener('shopify:section:select', function (e) {
            console.group('section:select')
           //  console.log(e.target)
           selectedSectionID = e.target.id;

        })
        
        document.addEventListener('shopify:block:select', function (e) {
            console.group('block:select')
            // console.log(e.target)

            /*
            let section_splide = document.querySelector('#'+selectedSectionID+' .splide')
            let slide_nr = e.target
            console.log('slideshow: '+slideshow)
            console.log('splides: '+slideshow.splides)
            slideshow.go(1)
            */
        })
    }
})





// trustpilot splide slider
function updateSplideOptionsById(id, newOptions) {
  let splide = splideInstances[id]
  if (splide) {
    splide.destroy()
    splideInstances[id] = new Splide('#' + id, newOptions).mount()
  } else {
    console.warn('Splide instance with ID ' + id + ' not found.')
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var tpSplideElement = document.getElementById('tpSplide');
  if (tpSplideElement) {
    var slideCount = tpSplideElement.querySelectorAll('.splide__slide').length;

    var tpSplideOptions = {
      type: 'slide',
      width: '700px',
      speed: 650,
      perPage: slideCount === 1 ? 1 : 2,
      perMove: slideCount === 1 ? 1 : 2,
      pagination: false,
      drag: slideCount > 1,
      snap: true,
      flickPower: 200,
      gap: 12,
      easing: 'ease',
      arrows: slideCount > 1,
      breakpoints: {
        1140: {
          perPage: slideCount === 1 ? 1 : 3,
          perMove: slideCount === 1 ? 1 : 3,
        },
        770: {
          perPage: 1,
          perMove: 1,
          width: '100%',
          height: 'auto',
        },
      },
    };
    updateSplideOptionsById('tpSplide', tpSplideOptions);
  }
})